import React, { useEffect, useState } from 'react'
import { PropTypes } from 'prop-types'
import { useForm } from 'react-hook-form';
import { Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap'

import types from '../../../types/types';
import { isEmail, isMobilePhone, regexUserName, regexStandardName, regexPassword } from '../../../components/common/Util'
import { Loading } from '../../../components/common/Loading';
import { PageHeaderStandar } from '../../../components/common/PageHeaderStandar';
import { InputField } from '../../../components/common/InputField';
import { ButtonsSaveAndCancel } from '../../../components/common/ButtonsSaveAndCancel'
import SelectCombobox from '../../../components/common/SelectCombobox';
import Checkbox from '../../../components/common/Checkbox';
import ErrorMessage from '../../../components/common/ErrorMessage';
import { useisLoading } from '../../../hook/useisLoading';
import { message } from '../../../components/common/Notification';
import { UsersAPI, User, BillingAPI } from '../../../components/apis';
import Element from './Element';
import { ConfigurationElement } from '../../../components/apis/billing';

export const ElementEdition = (props, context) => {
    
    console.log("Enter into ElementEdition.js");

    // We check if Component is called form path '/configurationsElement/new' or path '/configurationsElement/edit/:id' to define if user is trying to create a element or editing it.
    const isNewElement = (props.id === undefined)?true:false;
    const [userRol, setUserRol] = useState(null);
    
    // Get user and token from Redux
    const { user, token } = useSelector(state => state.user);

    // Get all roles from Redux
    const { roles } = useSelector(state => state.roles);
    
    // Variable to show/hide "spinner" while loading page.
    const { isLoading, showSpinner, hideSpinner } = useisLoading(true);

    const [apiBilling, setApiBilling] = useState(null);

    // Stander useForm of react-hook-form Library
    const { register, handleSubmit, getValues, setValue, reset, formState: { errors } } = useForm({

        defaultValues: {
            // User default attribute for creation of new entity
            id: null,
            billing: true,
            cost: null,
            created_at: null,
            currency: 0,
            deleted_at: null,
            desc_client: null,
            description: null,
            discount_cost: false,
            discount_excd: null,
            end_at: null,
            excedent: null,
            monitoring: true,
            name: null,
            name_client: null,
            percentage: null,
            quantity: null,
            start_at: "TODAY",
            
            // backendError is used to set back-end-error message when service has fail (to show to the user)
            backendError: null,
            // onSubmitOk is used to control if onSubmit acction was success.
            onSubmitOk: null,
        }

    });

    // Load api service
    useEffect(() => {
        
        if(token){
            setApiBilling(new BillingAPI(token));
        }

    }, [token])
        
    // Load an empty web form if its called from "add element" button or load element values if its called form "editon button" (pencil in Element.js).
    useEffect(() => {

        if(apiBilling){
            if (isNewElement){

                // Stop spinnner and render page.
                hideSpinner();
            } else{ // We are "editing" an element.
                showSpinner();
            
                apiBilling.getConfigurationElementById(props.id).then(  (result) => {
                    const element = result.element;                    
                    setValue("billing", element.billing);
                    setValue("cost", element.cost);
                    setValue("created_at", element.created_at);
                    setValue("currency", element.currency);
                    setValue("deleted_at", element.deleted_at);
                    setValue("desc_client", element.desc_client);
                    setValue("description", element.description);
                    setValue("discount_cost", element.discount_cost);
                    setValue("discount_excd", element.discount_excd);
                    setValue("end_at", element.end_at);
                    setValue("excedent", element.excedent);
                    setValue("id", element.id);
                    setValue("monitoring", element.monitoring);
                    setValue("name", element.name);
                    setValue("name_client", element.name_client);
                    setValue("percentage", element.percentage);
                    setValue("quantity", element.quantity);
                    setValue("start_at", element.start_at);

                }).catch(err => {
                    console.log("Error getting configuration element data from ElementEdition.js: " + err)
                    setValue(types.ERROR,  context.t("There was a problem on our end. Please try again later."));

                }).finally(() => {

                    hideSpinner();

                });      
            }
        
        }
    }, [apiBilling]);


    // Function calls at form submit in order to save changes
    const onSubmit = data => {
        
        // Show spinner
        showSpinner();
        if (isNewElement){
            
            // Create "new element objet" if its a new element
            const newElement = new ConfigurationElement({
                "id": null,
                "quantity": getValues().quantity,
                "cost": parseInt(getValues().cost),
                // "discount_cost": getValues().discount_cost,
                "discount_cost": 0,
                "description": getValues().description,
                // "created_at": getValues().created_at,
                "name_client": getValues().name_client,
                "excedent": parseFloat(getValues().excedent),
                "monitoring": getValues().monitoring,
                "created_at": null,
                // "created_at": "**TODAY**",
                // "start_at": getValues().start_at,
                "start_at": "**TODAY**",
                // "end_at": getValues().end_at,
                "end_at": null,
                // "deleted_at": getValues().deleted_at,
                "deleted_at": null,
                "billing": getValues().billing,
                "percentage": parseFloat(getValues().percentage),
                "name": getValues().name,
                "currency": getValues().currency,
                "discount_excd": getValues().discount_excd,
                "desc_client": getValues().desc_client
            });
                            
            // Call function to create "new" element
            apiBilling.createConfigurationElement(newElement, context).then(() => {
                
                // Set onSubmitOk in "true" in order to redirect to the user list after crete the new element.
                setValue("onSubmitOk",  true );

                // Stop spinnner and render page.
                hideSpinner();
                
                message(context.t("Element creation"), context.t("Element created successfully"));
            
            }).catch(err => {
                console.log("NewElement onSubmit error: " + err);
                // Set "backendError" show a back-end error as message to the user at the top.
                setValue("backendError", context.t(err.message));
                
            }).finally( () =>{
                // Stop spinnner and render page.
                hideSpinner();
            });

        } else { // It's a element edition.

            // Show spinner
            showSpinner();
            
            console.log("getValues().id: " + getValues().id);
            debugger

            // Create "new element objet"
            const elementToModify = new ConfigurationElement({

                "end_at": getValues().account_id,
                "quantity": getValues().quantity,
                "cost":  parseInt(getValues().cost),
                "discount_cost": getValues().discount_cost,
                "description": getValues().description,
                // "created_at": getValues().created_at,
                "created_at": null,
                "name_client": getValues().name_client,
                "excedent":  parseFloat(getValues().excedent),
                "monitoring": getValues().monitoring,
                // "start_at": getValues().start_at,
                "start_at": null,
                // "deleted_at": getValues().deleted_at,
                "deleted_at": null,
                "billing": getValues().billing,
                "percentage":  parseInt(getValues().percentage),
                "name": getValues().name,
                "currency":  parseInt(getValues().currency),
                "discount_excd": getValues().discount_excd,
                "desc_client": getValues().desc_client
            });

            
            // Call function to create "new" element
            apiBilling.update(elementToModify).then(() => {        
                // Set onSubmitOk in "true" in order to redirect to the user list after update the user values.
                setValue("onSubmitOk",  true );
                message(context.t("Element update"), context.t("Element updated successfully"));

            }).catch(err => {
                console.log("EdithElement onSubmit error: " + err);
                // Set "backendError" show a back-end error as message to the user at the top.
                setValue("backendError",  context.t(err.message) );
            
            }).finally( () =>{
                // Stop spinnner and render page.
                hideSpinner();
            });
        } // End Else
    };
        
    // If OnSubmit was success, redirect to element list
    if (getValues().onSubmitOk){
        // TODO: Check this redirect. To "/management" is it ok???
        return <Redirect to='/management' />
    }

    if (isLoading) {
        return <Loading/>
    } else {
        return (
            <Container fluid>
                {/* If "backendError" has value, it shows to the user */}
                <ErrorMessage message={getValues().backendError}/>

                {/* Page header has Title and Subtite of the page */}
                <PageHeaderStandar title={context.t('Element')} subtitle={ (isNewElement)?context.t('Add'):context.t('Edit') } />

                <Card small="true" style={{ marginBottom: '20px'}}>
                    <Form validate="true" onSubmit={ handleSubmit(onSubmit) } style={{ padding: "10px"}}>
                        <input type={'hidden'} {...register("id")} />
                        <Row>
                            <Col lg="6">
                                {/* {
                                (isNewElement)?(
                                    <>
                                        <InputField label={context.t('Password')} type="password" name="password" placeholder={context.t('********')} 
                                            errors={errors} 
                                            useFormRegister= {
                                            register("password", { 
                                                required: context.t("This is required"),
                                                pattern: {
                                                value: regexPassword(), // eslint-disable-line 
                                                message: context.t("Password must be between 8 and 30 characters, at least one uppercase, one lowercase and one special character"),
                                                }
                                            })
                                            }
                                        />
                                    </>
                                ):(null)
                            } */}
                                <InputField type="text"
                                    label= { context.t('Name') }
                                    name="name"
                                    placeholder={ context.t('Name') }
                                    errors={errors} 
                                    useFormRegister= {
                                    register("name", { 
                                        required: context.t("This is required"), 
                                        pattern: {
                                        value: regexStandardName(),
                                        message: context.t("Value entered is not allowed"),
                                        }
                                    })
                                    }
                                />
                                <InputField type="text"
                                    label= { context.t('Commercial Name') }
                                    name="name_client"
                                    placeholder={ context.t('Commercial Name') }
                                    errors={errors} 
                                    useFormRegister= {
                                    register("name_client", { 
                                        required: context.t("This is required"), 
                                        pattern: {
                                        value: regexStandardName(),
                                        message: context.t("Value entered is not allowed"),
                                        }
                                    })
                                    }
                                />
                                <InputField type="text"
                                    label= { context.t('Description') }
                                    name="description"
                                    placeholder={ context.t('Description') }
                                    errors={errors} 
                                    useFormRegister= {
                                    register("description", { 
                                        required: context.t("This is required"),
                                    })
                                    }
                                />
                                <InputField type="text"
                                    label= { context.t('Commercial Description') }
                                    name="desc_client"
                                    placeholder={ context.t('Commercial Description') }
                                    errors={errors} 
                                    useFormRegister= {
                                    register("desc_client", { 
                                        required: context.t("This is required"),
                                    })
                                    }
                                />
                                <InputField type="text"
                                    label= { context.t('Start At') }
                                    name="start_at"
                                    placeholder={ context.t('2022-01-01T01:01:01-03:00') }
                                    errors={errors} 
                                    useFormRegister= {
                                    register("start_at", { 
                                        required: context.t("This is required"), 
                                    })
                                    }
                                />
                                <InputField type="text"
                                    label= { context.t('End At') }
                                    name="end_at"
                                    placeholder={ context.t('2022-01-01T01:01:01-03:00') }
                                    errors={errors} 
                                    useFormRegister= {
                                    register("end_at", { 
                                        required: context.t("This is required"), 
                                    })
                                    }
                                />
                                <InputField type="text"
                                    label= { context.t('Deleted At') }
                                    name="deleted_at"
                                    placeholder={ context.t('2022-01-01T01:01:01-03:00') }
                                    errors={errors} 
                                    useFormRegister= {
                                    register("deleted_at", { 
                                        required: context.t("This is required"), 
                                    })
                                    }
                                />                          

                            </Col>
                            <Col lg="6">
                                                                      
                                <Checkbox label={context.t('Billable')} name="billing" useFormRegister= {register("billing", {})}  />
                                
                                <InputField type="text"
                                    label= { context.t('Cost') }
                                    name="cost"
                                    placeholder={ context.t('10') }
                                    errors={errors} 
                                    useFormRegister= {
                                    register("cost", { 
                                        required: context.t("This is required"), 
                                    })
                                    }
                                />
                                <InputField type="text"
                                    label= { context.t('Currency') }
                                    name="currency"
                                    placeholder={ context.t('USD') }
                                    errors={errors} 
                                    disabled={true}
                                    useFormRegister= {
                                    register("currency", { 
                                        required: context.t("This is required"), 
                                    })
                                    }
                                />
                                <InputField type="text"
                                    label= { context.t('Quantity') }
                                    name="quantity"
                                    placeholder={ context.t('1000') }
                                    errors={errors} 
                                    useFormRegister= {
                                    register("quantity", { 
                                        required: context.t("This is required"), 
                                    })
                                    }
                                />
                                
                                <Checkbox label={context.t('Monitoring')} name="monitoring" useFormRegister= {register("monitoring", {})}  />
                                
                                <Checkbox label={context.t('Has discount')} name="discount_cost" useFormRegister= {register("discount_cost", {})}  />
                                
                                <InputField type="text"
                                    label= { context.t('Discount on surplus') }
                                    name="discount_excd"
                                    placeholder={ context.t('20') }
                                    errors={errors} 
                                    useFormRegister= {
                                    register("discount_excd", { 
                                        required: context.t("This is required"), 
                                    })
                                    }
                                />
                                <InputField type="text"
                                    label= { context.t('Percentage') }
                                    name="percentage"
                                    placeholder={ context.t('20') }
                                    errors={errors} 
                                    useFormRegister= {
                                    register("percentage", { 
                                        required: context.t("This is required"), 
                                    })
                                    }
                                />
                                <InputField type="text"
                                    label= { context.t('Excedent') }
                                    name="excedent"
                                    placeholder={ context.t('0.002') }
                                    errors={errors} 
                                    useFormRegister= {
                                    register("excedent", { 
                                        required: context.t("This is required"), 
                                    })
                                    }
                                />                                
                            </Col>
                        </Row>
                        <hr/>
                        <ButtonsSaveAndCancel/>
                    </Form>
                </Card>
            </Container>
        )
    }
}


ElementEdition.contextTypes = {
  t: PropTypes.func.isRequired
}

export default ElementEdition